import React, { useEffect, useState } from 'react';
import { subscribeToTokenBalance } from '../services/tokenService';

export default function ProfileTokenBalance({ uid }) {
  const [balance, setBalance] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setError(false);
    return subscribeToTokenBalance(uid, value => { setBalance(value); setError(false); }, () => setError(true));
  }, [uid, attempt]);
  return <section className="profile-token-balance" aria-labelledby="token-balance-title">
    <h3 id="token-balance-title">Token balance</h3>
    {error ? <p className="profile-feedback error" role="alert">Could not load your token balance.<button onClick={() => setAttempt(value => value + 1)}>Retry balance</button></p>
      : <><p className={balance !== null && balance <= 0 ? 'token-balance-value depleted' : 'token-balance-value'} role="status">{balance === null ? 'Loading...' : `${balance.toLocaleString()} tokens`}</p>
        <p>{balance !== null && balance <= 0 ? 'Ask a superadmin to add tokens before generating with AI.' : 'AI responses use the provider-reported input and output token total. A response may take your balance below zero.'}</p></>}
  </section>;
}
